import { render, staticRenderFns } from "./ReservoirTargetOverlay.vue?vue&type=template&id=2b4da2e4&scoped=true"
import script from "./ReservoirTargetOverlay.vue?vue&type=script&lang=js"
export * from "./ReservoirTargetOverlay.vue?vue&type=script&lang=js"
import style0 from "./ReservoirTargetOverlay.vue?vue&type=style&index=0&id=2b4da2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4da2e4",
  null
  
)

export default component.exports